/**
 * Backdrop — full-bleed catcher that closes a panel/menu/popover on an
 * outside press. `fixed` on web covers the whole viewport (so a tap anywhere
 * outside the panel dismisses it); native stays `absolute`, sized to the
 * nearest positioned ancestor. Shared by DateField, TimeField, LanguageMenu
 * and OptionSelect.
 */
import { Platform } from 'react-native'
import { Stack } from 'tamagui'

const isWeb = Platform.OS === 'web'

export function Backdrop({ onPress }: { onPress: () => void }) {
  return (
    <Stack
      position={isWeb ? ('fixed' as 'absolute') : 'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      onPress={onPress}
      zIndex={40}
    />
  )
}
